import * as Dialog from '@radix-ui/react-dialog'
import { Button } from '@/components/Button/Button'
import { memo } from 'react'

export const ConfirmDialog = memo(function ConfirmDialog({
  open,
  onOpenChange,
  onSubmit,
  disabled,
  triggerLabel,
  title,
  description,
  confirmLabel,
}: {
  open?: boolean
  onOpenChange?: (open: boolean) => void
  onSubmit: () => void
  disabled?: boolean
  triggerLabel: string
  title: string
  description: string
  confirmLabel: string
}) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Trigger asChild>
        <Button
          className="inline-flex items-center py-8 px-4 w-full justify-center lg:gap-2 mt-4"
          data-testid="btn-continue-submit"
          disabled={disabled}
        >
          {triggerLabel}
        </Button>
      </Dialog.Trigger>

      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40" />
        <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white dark:bg-pebble shadow-xl border border-gray-200 dark:border-gray-700 p-8 max-w-md w-full mx-4 z-50 focus:outline-none">
          <div className="text-center space-y-6">
            <div className="space-y-2">
              <Dialog.Title className="text-lg font-normal uppercase">
                {title}
              </Dialog.Title>
              <Dialog.Description className="text-sm text-gray-500">
                {description}
              </Dialog.Description>
            </div>
            <div className="flex justify-end">
              <Button
                className="flex-1 py-3 px-6 bg-black dark:bg-semiWhite text-white font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                onClick={onSubmit}
                disabled={disabled}
              >
                {confirmLabel}
              </Button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
})
